import { AssetGroup, AssetGroupInput } from '@/types/schemas/nhom-tscd.type';
import { useAssetGroup as useAssetGroupQuery } from '@/hooks/queries';

export const useAssetGroup = () => {
  const {
    assetGroups: groups,
    isLoading,
    addAssetGroup: addAssetGroupQuery,
    updateAssetGroup: updateAssetGroupQuery,
    deleteAssetGroup: deleteAssetGroupQuery,
    refreshAssetGroups,
    fetchAssetGroupsByType
  } = useAssetGroupQuery();

  const assetGroups = groups;

  const addAssetGroup = async (formData: AssetGroupInput): Promise<AssetGroup> => {
    try {
      const apiData: AssetGroupInput = {
        ma_nhom: formData.ma_nhom,
        ten_phan_nhom: formData.ten_phan_nhom,
        ten2: formData.ten2,
        trang_thai: formData.trang_thai,
        loai_nhom: formData.loai_nhom || 'TS1'
      };
      return await addAssetGroupQuery(apiData);
    } catch (error) {
      console.error('Error adding asset group:', error);
      throw error;
    }
  };

  const updateAssetGroup = async (data: AssetGroupInput & { uuid: string }): Promise<AssetGroup> => {
    try {
      const { uuid, ...formData } = data;

      const apiData: AssetGroupInput = {
        ma_nhom: formData.ma_nhom,
        ten_phan_nhom: formData.ten_phan_nhom,
        ten2: formData.ten2,
        trang_thai: formData.trang_thai,
        loai_nhom: formData.loai_nhom || 'TS1'
      };

      return await updateAssetGroupQuery(uuid, apiData);
    } catch (error) {
      console.error('Error updating asset group:', error);
      throw error;
    }
  };

  const deleteAssetGroup = async (id: string): Promise<void> => {
    try {
      await deleteAssetGroupQuery(id);
    } catch (error) {
      console.error('Error deleting asset group:', error);
      throw error;
    }
  };

  return {
    assetGroups,
    isLoading,
    addAssetGroup,
    updateAssetGroup,
    deleteAssetGroup,
    refreshAssetGroups,
    fetchAssetGroupsByType
  };
};
